<template>
    <form-modal
        ref="formModal"
        :title="getI18nModified({ prefix: 'COMMON.filter', modifier: 2 })"
        @handleHide="handleHide">
        <template v-slot:form>
            <form @submit.prevent="handleOk">
                <b-row>
                    <b-col md="12">
                        <b-form-group
                            :label="i18nPeriod"
                            class="required label-pdv"
                            label-for="filter-date"
                        >
                            <date-range-picker
                                :value.sync="filterModal.date"
                                :max-date="new Date()"
                                :disable-clean-button="true"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-form-group
                            :label="i18nBusinessUnit"
                            label-for="filter-business-unit"
                            class="required label-pdv"
                            :invalid-feedback="getI18n('ERROR_CODES.invalid_business_unit')"
                        >
                            <multiSelectWithService
                                :id="'filter-business-unit'"
                                ref="businessUnitMultiselect"
                                v-model="filterModal.business_unit"
                                :input-function="$v.filterModal.business_unit.id.$touch"
                                :select-class="validationClass($v.filterModal.business_unit.id)"
                                :service="'business-units'"
                                :searchable="true"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-form-group
                            :label="i18nRegional"
                            label-for="filter-regional"
                            class="label-pdv">
                            <multiSelectWithService
                                :id="'filter-regional'"
                                ref="regionalMultiselect"
                                v-model="filterModal.regionals"
                                :service="'pos-regionals'"
                                :searchable="true"
                                :multiple="true"
                                :parameters="parameters"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-form-group
                            :label="i18nChain"
                            label-for="filter-chain"
                            class="label-pdv">
                            <multiSelectWithService
                                :id="'filter-chain'"
                                ref="chainMultiselect"
                                v-model="filterModal.chains"
                                :service="'pos-chains'"
                                :searchable="true"
                                :multiple="true"
                                :parameters="parameters"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col md="6">
                        <b-form-group
                            :label="i18nChannel"
                            label-for="filter-channel"
                            class="label-pdv">
                            <multiSelectWithService
                                :id="'filter-channel'"
                                ref="channelMultiselect"
                                v-model="filterModal.channels"
                                :service="'pos-channels'"
                                :searchable="true"
                                :multiple="true"
                                :parameters="parameters"
                            />
                        </b-form-group>
                    </b-col>
                </b-row> -->
            </form>
        </template>
        <template v-slot:footer>
            <save-button
                ref="okButton"
                :busy="submitLoading"
                :disabled="submitLoading"
                :title="getI18n('ACTION.filter')"
                @onClick="handleOk"
            />
            <clear-filter-button
                @onClick="handleClearFilter"
            />
        </template>
    </form-modal>
</template>

<script>
import { required, integer, minValue } from 'vuelidate/lib/validators'
import swalFeedback from '@src/mixins/swalFeedback.vue'
import validationMixin from '@src/mixins/validation.vue'
import FormModal from '@/src/components/FormModal.vue'
import SaveButton from '@/src/components/SaveButton'
import ClearFilterButton from '@/src/components/ClearFilterButton'
import cloneObject from '@utils/clone-object'
import DateRangePicker from '@/src/components/DateRangePicker'
import multiSelectWithService from '@src/components/multiSelectWithService.vue'
import moment from 'moment';

const i18nKey = 'DASHBOARDS'
const i18nCommon = 'COMMON'

export default {
    components: {
        FormModal,
        SaveButton,
        ClearFilterButton,
        DateRangePicker,
        multiSelectWithService,
    },
    mixins: [
        validationMixin,
        swalFeedback,
    ],
    props: {
        handleSubmit: {
            type: Function,
            required: true,
            default: function () {},
        },
    },
    data() {
        return {
            i18nKey,
            i18nCommon,
            filterModal: {},
            submitLoading: false,
            parameters: {
                with_admin: true,
                per_page: 1000,
                page: 1,
                orderBy: 'name',
                sortedBy: 'asc',
            },
            defaultCategory: { id: null, name: '', parent_id: null },
            valueConsistsOf: 'LEAF_PRIORITY',
        }
    },
    validations: {
        filterModal: {
            business_unit: {
                id: {
                    required,
                    integer,
                    minValue: minValue(1)
                },
            },
        }
    },
    computed: {
        i18nPeriod() {
            return this.getI18n(i18nCommon, 'period')
        },
        i18nDueDate() {
            return this.getI18n(i18nKey, 'TITLES.due_date')
        },
        i18nRegional() {
            return this.getI18n('POS', 'TITLES.regional')
        },
        i18nChain() {
            return this.getI18n('POS', 'TITLES.chain')
        },
        i18nBusinessUnit() {
            return this.getI18n(i18nCommon, 'business_unit')
        },
        i18nChannel() {
            return this.getI18n('POS', 'TITLES.channel')
        },
        i18nProductCategory() {
            return this.getI18n('PRODUCT_CATEGORIES', 'TITLES.product_category')
        },
    },
    methods: {
        resetValidation() {
            this.$nextTick(() => this.$v.$reset())
        },
        showModal(previousFilters) {
            this.filterModal = cloneObject(previousFilters);
            this.submitLoading = false
            this.$refs.formModal.show()
        },
        cleanModal() {
            this.filterModal = Object.assign(this.filterModal, {
                date: {
                    start: moment().startOf('day').add(-30, 'days').toDate(),
                    end: moment().startOf('day').toDate()
                },
                business_unit: null,
                regionals: [],
                chains: [],
                channels: [],
            })
            this.resetValidation()
        },
        handleHide() {
            if (!this.submitLoading) {
                this.cleanModal();
            }
        },
        handleOk() {
            if (this.submitLoading) {
                return;
            }

            this.$v.filterModal.$touch()
            if (!this.$v.filterModal.$invalid && !this.submitLoading) {
                this.submitLoading = true;
                this.$props.handleSubmit(this.filterModal);
                this.$refs.formModal.hide()
            }
        },
        async handleClearFilter() {
            this.cleanModal()
        }
    },
}
</script>
